import { state } from '../state-manager/state-model';
import { message } from '../message/message-model';

export var ERRORS = {
  // launcher
  Maintenance: '-1',
  InvalidChannellingUser: '-2',
  InvalidSession: '-3',
  BadUser: '-4',
  NotVerifiedUser: '-5',
  NotVerifiedRegularly: '-6',
  TooYoung: '-7',
  MFANotAuthorized: '-9',

  // 개인암호
  MfaPasswdNotMatched: '2007',
  MfaPasswdTooManyTries: '2008',

  // 보안 SMS
  MfaSmsResendFailed: '2009',
  MfaSmsNotMatched: '2011',
  MfaSmsTooManyTries: '2012',
  MfaSmsTimeout: '2013',
  MfaSmsNoSecuritySms: '2015', // SMS 서비스 사용 안함

  // 이 모듈
  MFADeprecated: '2001',
  GetRechargeLinkError: '3001',

  // 마지막 로그인 시각이 변했을 경우
  InvalidSignedDate: '4001',
  Silent: '9000',

  // 웹서버에서 핸들링하지 못한 에러의 기본값
  Unknown: '9999'
};

/** 뉴맞고에서는 jQuery Promise 를 썼지만, 포커는 Promise 체인 상에서 실행된다. (IE에서는 Promise polyfill) */
export function handleError(err) {
  var code = err.code || err.resultCode || err.statusText || err.name || err;
  var description = err.description || err.resultText || err.message || 'Not specified';

  if (err.isHandled) {
    return; // 이미 처리한 에러
  }

  switch (code.toString()) {
    case ERRORS.Maintenance:
      var maintenanceMsg = state.get('maintenanceMessage');
      var responseURI;
      var msgFromAPI;

      if (err.customURIScheme) responseURI = new URLSearchParams(err.customURIScheme);
      if (responseURI && responseURI.has('rmsg')) msgFromAPI = responseURI.get('rmsg');

      message.show('게임 서비스 점검이 진행 중입니다!', [
        '<strong>안정적인 게임 서비스를 위해',
        '점검을 실시합니다.</strong>',
        '<div style="padding: 1px 0;">',
        maintenanceMsg || msgFromAPI || '',
        '</div>',
        '서비스 이용에 불편을 드려 대단히 죄송합니다.',
        '더 나은 서비스로 보답해 드리고자',
        '더욱 최선을 다하겠습니다.'
      ]);
      break;

    case ERRORS.InvalidChannellingUser:
      message.show('죄송합니다.', '이용 불가능한 채널링 유저입니다.');
      break;

    case ERRORS.InvalidSession:
      message.show('죄송합니다.', '로그인 정보가 유효하지 않습니다.');
      break;

    case ERRORS.BadUser:
      message.show('죄송합니다.', '폴리스 제재를 받고 있는 유저입니다.');
      break;

    case ERRORS.NotVerifiedUser:
      message.show('죄송합니다.', '본인인증을 하지 않은 유저입니다.');
      break;

    case ERRORS.NotVerifiedRegularly:
      message.show('죄송합니다.', '본인 확인(연 1회)을 하지 않은 유저입니다.');
      break;

    case ERRORS.TooYoung:
      message.show('죄송합니다.', '미성년자입니다.');
      break;

    case ERRORS.MFANotAuthorized:
      // App State에 보안서비스 인증 필요로 표시
      state.authenticateMFA(false);
      message.show('죄송합니다', [
        '보안 서비스 인증 유효 시간이 지났습니다.',
        '다시 시도해주세요.'
      ]);
      break;

    case ERRORS.Unknown:
      message.show('죄송합니다', [
        '일시적으로 에러가 발생하였습니다.',
        '잠시 후 다시 시도해 주세요.'
      ]);
      break;

    case ERRORS.MFADeprecated:
      message.show('보안 서비스 안내', [
        '피망 게임에서 지원하지 않는',
        '보안서비스를 이용하고 계십니다.',
        '<strong>"개인 암호"</strong>나 <strong>"보안 SMS"</strong>로 변경하시면',
        '피망 포커를 안전하게 이용하실 수 있습니다.'
      ]);
      break;

    case ERRORS.MfaPasswdNotMatched:
      message.show('개인 암호', [
        '<strong>개인암호가 틀렸습니다.</strong>',
        '다시 정확하게 입력해 주십시오'
      ]);
      break;

    case ERRORS.MfaPasswdTooManyTries:
      message.show('개인 암호', [
        '<strong>개인암호가 5회 이상 틀렸습니다.</strong>',
        '개인암호 서비스를 해지하셔야',
        '서비스를 정상적으로 이용하실 수 있습니다.'
      ]);
      break;

    case ERRORS.MfaSmsTooManyTries:
      message.show('보안 SMS', [
        '<strong>인증번호가 5회 이상 틀렸습니다.</strong>',
        '보안 SMS 서비스를 해지하셔야',
        '서비스를 정상적으로 이용하실 수 있습니다.'
      ]);
      break;

    case ERRORS.MfaSmsNoSecuritySms:
      message.show('보안 SMS', '보안 SMS 서비스를 사용중이 아닙니다.');
      break;

    case ERRORS.MfaSmsNotMatched:
      message.show('보안 SMS', '인증번호를 다시 확인해 주세요.');
      break;

    case ERRORS.MfaSmsTimeout:
      message.show('보안 SMS', '시간이 초과되었습니다. 인증번호를 다시 받아주시기 바랍니다.');
      break;

    case ERRORS.GetRechargeLinkError:
      message.show('죄송합니다', [
        '일시적으로 에러가 발생하였습니다.',
        '잠시 후 다시 시도해 주세요.'
      ]);
      break;

    case ERRORS.Silent:
      break;

    case ERRORS.InvalidSignedDate:
      message.show(
        '알림',
        ['로그인 정보가 변경되었습니다.', '페이지를 새로 고침합니다.'],
        function () {
          location.reload();
        }
      );
      break;

    case 'Conflict':
    case 'Forbidden':
    case 'Unauthorized':
      message.show('죄송합니다', '로그인 정보가 유효하지 않습니다.', function () {
        location.reload();
      });
      break;

    default:
      // 다른 서버가 배포될 때 userInfo 를 Polling 하다 에러 발생. 정의된 에러가 아닐 경우, 무시
      console.info('Unexpected error', code, description);
  }

  err.isHandled = true;
  return err;
}
